import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { ShoppingBag, Heart, Menu, X, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useStore } from "@/context/StoreContext";

const links = [
  { to: "/shop", label: "Shop" },
  { to: "/shop?category=Dresses", label: "Dresses" },
  { to: "/shop?category=Tops", label: "Tops" },
  { to: "/shop?category=Outerwear", label: "Outerwear" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const { cartCount } = useStore();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-pearl/80 border-b border-line">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Menu">
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
        <nav className="hidden md:flex items-center gap-8 flex-1">
          {links.map((l) => (
            <Link key={l.label} to={l.to} className="label-caps text-ink/70 hover:text-ink transition-colors" data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/" className="font-serif-display text-2xl sm:text-3xl tracking-[0.35em] uppercase absolute left-1/2 -translate-x-1/2" data-testid="brand-logo">
          MODA
        </Link>

        <div className="flex items-center gap-4 sm:gap-5 flex-1 justify-end">
          <Link to="/wishlist" aria-label="Wishlist" data-testid="nav-wishlist"><Heart strokeWidth={1.5} className="w-5 h-5 hover:text-wine transition-colors" /></Link>
          {user && user.role === "admin" && (
            <>
              <Link to="/admin" className="label-caps hidden sm:inline hover:text-wine transition-colors" data-testid="nav-admin">Admin</Link>
              <button onClick={async () => { await logout(); nav("/"); }} aria-label="Logout" data-testid="nav-logout"><LogOut strokeWidth={1.5} className="w-5 h-5 hover:text-wine transition-colors" /></button>
            </>
          )}
          <Link to="/cart" className="relative" aria-label="Cart" data-testid="nav-cart">
            <ShoppingBag strokeWidth={1.5} className="w-5 h-5" />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-ink text-pearl text-[10px] w-4 h-4 flex items-center justify-center" data-testid="cart-count">{cartCount}</span>
            )}
          </Link>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-line bg-pearl px-5 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="label-caps" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</Link>
          ))}
          {user?.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="label-caps" data-testid="mobile-nav-admin">Admin</Link>}
        </div>
      )}
    </header>
  );
}
